module.exports = __webpack_public_path__ + "static/media/fa-solid-900.b75b4bfe.woff2";